import React from "react"
import { SectionTitle, DataTable, StatusBadge, PaymentTypeIndicator } from "../components"
import { cardStyle, loadingStyle, emptyBoxStyle } from "../styles/commonStyles"
import { formatThaiBuddhistDate } from "../../../libs/dateUtils"
import { calculatePlanStatus, snakeToTitleCase } from "../utils/helpers"

const PlansTab = ({ customer, loading }) => {
	if (loading) {
		return (
			<div className="card-style" style={cardStyle}>
				<div style={loadingStyle}>กำลังโหลด...</div>
			</div>
		)
	}

	if (!customer || !customer.plans || customer.plans.length === 0) {
		return (
			<div className="card-style" style={cardStyle}>
				<SectionTitle title="ประวัติแพ็คเกจ" />
				<div style={emptyBoxStyle}>
					<span>ไม่พบข้อมูลแพ็คเกจ</span>
				</div>
			</div>
		)
	}

	const headers = [
		"วันที่สร้าง",
		"ชื่อแพ็คเกจ",
		"ประเภท",
		"ประเภทการชำระเงิน",
		"วันที่เริ่มต้นแพ็คเกจ",
		"วันที่สิ้นสุดแพ็คเกจ",
		"สถานะ",
		"รหัสคำสั่งซื้อ",
	]

	const rows = customer.plans.map((plan) => {
		const status = calculatePlanStatus(plan)

		return [
			formatThaiBuddhistDate(plan.createdAt),
			plan.name,
			snakeToTitleCase(plan.type),
			<PaymentTypeIndicator key="isRecurring" isRecurring={plan.isRecurring} planType={plan.type} />,
			formatThaiBuddhistDate(plan.startAt),
			formatThaiBuddhistDate(plan.expiredAt),
			<StatusBadge key="status" status={status} />,
			plan.orderId || "-",
		]
	})

	return (
		<div className="card-style" style={cardStyle}>
			<SectionTitle title="ประวัติแพ็คเกจ" />
			<DataTable headers={headers} rows={rows} emptyMessage="ไม่พบข้อมูลแพ็คเกจ" />
		</div>
	)
}

export default PlansTab
